import { reducerWithInitialState } from 'typescript-fsa-reducers';
import type { ApplicationState } from '../index';
import { setActiveProject } from './project.actions';

export interface ProjectState {
    /** Account the selection was resolved for; a mismatch with auth.user means unresolved. */
    userId: number | null;
    activeProjectId: string | null;
}

export const defaultState: ProjectState = {
    userId: null,
    activeProjectId: null,
};

export const selectIsProjectResolved = (state: ApplicationState): boolean =>
    state.auth.user !== undefined && state.project.userId === state.auth.user.id;

/** The id to send as `X-Project-Id`; null until resolved for the signed-in account. */
export const selectActiveProjectId = (state: ApplicationState): string | null =>
    selectIsProjectResolved(state) ? state.project.activeProjectId : null;

export default reducerWithInitialState(defaultState).case(setActiveProject, (_, payload) => ({
    userId: payload.userId,
    activeProjectId: payload.projectId,
}));
